const privateResidenceMain = (() => {
  const pagePrivateResidence = (document.getElementById("pagePrivateResidence") != null);
  if (pagePrivateResidence) {



    let sec = document.querySelector('#jsSecMain');
    let wrap = sec.querySelector('.js-main-wrap');
    let box = wrap.querySelector('.js-img-box');
    let blur = box.querySelector('.js-blur');
    let cover = box.querySelector('.js-cover');


    let to1 = gsap.to(blur, {
      backdropFilter: 'blur(6px)',
      ease: "none",
      scrollTrigger: {
        trigger: wrap,
        start: 'top top',
        end: 'bottom center',
        scrub: 0,
        // markers: true
      }
    })
    let to2 = gsap.to(cover, {
      opacity: .7,
      ease: "none",
      scrollTrigger: {
        trigger: wrap,
        start: 'top top',
        end: 'bottom center',
        scrub: 0,
        // markers: true
      }
    })


    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        to1.scrollTrigger.refresh()
        to2.scrollTrigger.refresh()
        // console.log('comParallax refresh');
      });
    });
    observer.observe(target);



  }
})()
export default privateResidenceMain;